import axios from 'axios'
import { DataUpdatePayload, StrictDataUpdateV1Payload } from './data-update-schema'

export type DataUpdateRequestPayload = DataUpdatePayload | StrictDataUpdateV1Payload

export type RequestDataUpdate = (payload: DataUpdateRequestPayload) => Promise<void>

/**
 * POST a data-update payload to the Wistor data-update endpoint.
 *
 * Curried on the URL, because the URL is derived once (see use-app-ctx) while
 * the payload differs per call site. The endpoint answers 200 with an empty
 * body, so there is nothing to resolve: callers get void on success and the
 * raw axios error on failure.
 */
export function requestDataUpdate(dataUpdateUrl: string): RequestDataUpdate {
  return async function requestDataUpdate(payload: DataUpdateRequestPayload) {
    await axios.post(dataUpdateUrl, payload, {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    })
  }
}
